module.exports = __webpack_public_path__ + "static/media/zendesk.348573cc.png";